import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { INBOUND_WEBHOOK_ENDPOINTS, buildQueryString } from '../endpoints';

const inboundWebhookService = {
  getEndpoints: async (formSchemaId) => {
    const params = {};
    if (formSchemaId) params.formSchemaId = formSchemaId;
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${INBOUND_WEBHOOK_ENDPOINTS.LIST_ENDPOINTS}${queryString}`)
    );
  },

  getEndpointById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(INBOUND_WEBHOOK_ENDPOINTS.GET_ENDPOINT(id))
    );
  },

  createEndpoint: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(INBOUND_WEBHOOK_ENDPOINTS.CREATE_ENDPOINT, data)
    );
  },

  updateEndpoint: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(INBOUND_WEBHOOK_ENDPOINTS.UPDATE_ENDPOINT(id), data)
    );
  },

  deleteEndpoint: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(INBOUND_WEBHOOK_ENDPOINTS.DELETE_ENDPOINT(id))
    );
  },

  testEndpoint: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(INBOUND_WEBHOOK_ENDPOINTS.TEST_ENDPOINT(id))
    );
  },

  regenerateToken: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(INBOUND_WEBHOOK_ENDPOINTS.REGENERATE_TOKEN(id))
    );
  },

  getDeliveries: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${INBOUND_WEBHOOK_ENDPOINTS.LIST_DELIVERIES}${queryString}`)
    );
  },

  getDeliveryDetail: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(INBOUND_WEBHOOK_ENDPOINTS.GET_DELIVERY(id))
    );
  },

  getSchema: async (token) => {
    return apiRequest(() =>
      axiosInstance.get(INBOUND_WEBHOOK_ENDPOINTS.SCHEMA(token))
    );
  },
};

export default inboundWebhookService;
